import { utils } from 'ethers';

// returns the checksummed address if the address is valid, otherwise returns false
export function isAddress(value: any): string | false {
  try {
    return utils.getAddress(value)
  } catch {
    return false
  }
}